import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

import { MessageScreen } from '@/components/message-screen';

export function NotFoundPage() {
  useEffect(() => {
    Sentry.captureException(
      new Error(`PageNotFound: ${window.location.pathname}`),
    );
  }, []);

  return (
    <>
      <title>Página Não Encontrada - Fintalk Biometrics</title>

      <MessageScreen
        heading="404"
        title="Página Não Encontrada"
        message="A página que você está procurando não existe."
      />
    </>
  );
}
